import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Form } from '@zillow/constellation-10';

import { DISPLAY_SERVER_ERROR_AT } from '../../../constants/WizardConstants';

import { ModularListingContext } from '../../../containers/CreateListingPage/context';
import { WizardContext } from '../../Wizard/context';

import WizardAlert from '../../WizardAlert';
import WizardTipCardContainer from '../../WizardTipCardContainer';

import PageWizard from '../../Wizard/PageWizard';

import { RECS } from '../../../constants/RecommendationsConstants';

import WizardTipContent from './components/WizardTipContent';
import HideAddressFieldSet from './components/HideAddressFieldSet';
import { WizardFlexContainer, WizardFormSectionContainer, WizardHeading } from '../../../styles/wizard';

const propTypes = {
  onGoToPrevStep: PropTypes.func.isRequired,
  onGoToNextStep: PropTypes.func.isRequired,
  wizardTitle: PropTypes.node.isRequired,
  progressStepper: PropTypes.node.isRequired,
  totalSteps: PropTypes.number.isRequired,
  currentStepIndex: PropTypes.number.isRequired,
  showDesktopViewBreakpoint: PropTypes.oneOf(['md' | 'xl' | 'xxl']).isRequired,
};
const defaultProps = {};

const HidePropertyAddress = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}) => {
  const {
    wizardState: { isFetchingData },
  } = useContext(WizardContext);

  const {
    modularListingState: { serverErrorObj },
  } = useContext(ModularListingContext);

  const {
    properties: {
      recommendations: { recommendations },
    },
  } = useSelector((state) => state);

  const hideAddressRec = recommendations?.find((item) => item.type === RECS.HIDE_STREET_ADDRESS);

  const [clickedNext, setClickedNext] = useState(false);
  const [clickedBackNext, setClickedBack] = useState(false);

  useEffect(() => {
    const { fieldName } = serverErrorObj;

    if (!fieldName && !isFetchingData) {
      checkNavToStep();
    }
  }, [isFetchingData]);

  const checkNavToStep = () => {
    if (clickedNext) {
      onNextClick();
    }

    if (clickedBackNext) {
      onBackClick();
    }
  };

  const onNextClick = () => {
    if (isFetchingData) {
      setClickedNext(true);
      return;
    }

    onGoToNextStep();
  };

  const onBackClick = () => {
    if (isFetchingData) {
      setClickedBack(true);
      return;
    }

    onGoToPrevStep();
  };

  return (
    <PageWizard
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onNextClick}
      onBackClick={onBackClick}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
      {...rest}
    >
      <div data-testid="HidePropertyAddress">
        <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.PAGE} />

        <WizardFlexContainer>
          {/* cast as div to prevent cannot appear as a descendant of form error */}
          <Form asChild={true} onSubmit={(e) => e.preventDefault()}>
            <div>
              <WizardFormSectionContainer>
                <WizardHeading level={1} textStyle="heading-sm">
                  Do you want to hide the property address on this listing?
                </WizardHeading>

                <HideAddressFieldSet />
              </WizardFormSectionContainer>
            </div>
          </Form>

          <WizardTipCardContainer
            header="Showing the property address"
            showDesktopViewBreakpoint={showDesktopViewBreakpoint}
          >
            <WizardTipContent outcomeStats={hideAddressRec?.outcomeStats} source={hideAddressRec?.source?.tip} />
          </WizardTipCardContainer>
        </WizardFlexContainer>
      </div>
    </PageWizard>
  );
};

HidePropertyAddress.propTypes = propTypes;
HidePropertyAddress.defaultProps = defaultProps;

export default HidePropertyAddress;
